// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2wA6z","shape":"Checkbox_shape__23e7s","isChecked":"Checkbox_isChecked__2QFGk"};